import { render, staticRenderFns } from "./BenificiaryBus.vue?vue&type=template&id=0a626f68&scoped=true&"
import script from "./BenificiaryBus.vue?vue&type=script&lang=js&"
export * from "./BenificiaryBus.vue?vue&type=script&lang=js&"
import style0 from "./BenificiaryBus.vue?vue&type=style&index=0&id=0a626f68&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a626f68",
  null
  
)

export default component.exports